import { type ReactNode } from 'react';

import { PageHeader } from '@/ui/PageHeader';

const DESCRICAO =
  'Central única do ciclo de integração com a Secretaria de Finanças: reservas de dotação, status do envio, geração de lotes de empenho, conciliação, relatórios fiscais e histórico protocolado.';

/** FIN-030/031: cabeçalho único do hub SOF — no protótipo as 6 telas vivem
 * dentro de um único `<Tabs>`, então o título e a descrição não mudam por
 * aba (só os botões de ação, passados como `children`). */
export function SofHeader({ children }: { children?: ReactNode }) {
  return (
    <PageHeader title="SOF" description={DESCRICAO}>
      {children}
    </PageHeader>
  );
}
